import { View } from "@westpierstudio/luma/mvc";
import { GameServices } from "game/GameServices";
import { forEach } from "lodash";
import { Emitter } from "pixi-particles";

type BorderEmitter = {
    top: Emitter,
    bottom: Emitter,
    left: Emitter,
    right: Emitter
}

export class ReelEffects extends View {
    private starParticles!: BorderEmitter;
    private orbParticles!: BorderEmitter;

    constructor(protected override readonly services: GameServices) {
        super(services);

        this.setupStarParticles();
        this.setupOrbParticles();

        this.disable();
    }

    override reset(): void {
        this.disable();
    }

    setupStarParticles(): void {
        const {factory, resources} = this.services;

        this.starParticles = {
            top: factory.createParticleEmitter(resources.getSpec(`particles`).reeljackpotstars, this),
            bottom: factory.createParticleEmitter(resources.getSpec(`particles`).reeljackpotstars, this),
            left: factory.createParticleEmitter(resources.getSpec(`particles`).reeljackpotstars, this),
            right: factory.createParticleEmitter(resources.getSpec(`particles`).reeljackpotstars, this)
        };

        const {reelEffectsTop, reelEffectsBottom, reelEffectsLeft, reelEffectsRight} = resources.getSpec(`reelEffects`);

        this.starParticles.top.spawnPos = reelEffectsTop.spawnPos;

        this.starParticles.bottom.spawnPos = reelEffectsBottom.spawnPos;
        this.starParticles.bottom.minStartRotation = this.starParticles.bottom.maxStartRotation = reelEffectsBottom.rotation;

        this.starParticles.left.spawnPos = reelEffectsLeft.spawnPos;
        this.starParticles.left.minStartRotation = this.starParticles.left.maxStartRotation = reelEffectsLeft.rotation;
        this.starParticles.left.spawnRect = reelEffectsLeft.spawnRect;
        this.starParticles.left.frequency /= reelEffectsLeft.spawnRect.height / reelEffectsBottom.spawnRect.width;

        this.starParticles.right.spawnPos = reelEffectsRight.spawnPos;
        this.starParticles.right.minStartRotation = this.starParticles.right.maxStartRotation = reelEffectsRight.rotation;
        this.starParticles.right.spawnRect = reelEffectsRight.spawnRect;
        this.starParticles.right.frequency /= reelEffectsRight.spawnRect.height / reelEffectsBottom.spawnRect.width;
    }

    setupOrbParticles(): void {
        const {factory, resources} = this.services;

        this.orbParticles = {
            top: factory.createParticleEmitter(resources.getSpec(`particles`).reeljackpotorbs, this),
            bottom: factory.createParticleEmitter(resources.getSpec(`particles`).reeljackpotorbs, this),
            left: factory.createParticleEmitter(resources.getSpec(`particles`).reeljackpotorbs, this),
            right: factory.createParticleEmitter(resources.getSpec(`particles`).reeljackpotorbs, this)
        };

        const {reelEffectsTop, reelEffectsBottom, reelEffectsLeft, reelEffectsRight} = resources.getSpec(`reelEffects`);

        this.orbParticles.top.spawnPos = reelEffectsTop.spawnPos;

        this.orbParticles.bottom.spawnPos = reelEffectsBottom.spawnPos;
        this.orbParticles.bottom.minStartRotation = this.orbParticles.bottom.maxStartRotation = reelEffectsBottom.rotation;

        this.orbParticles.left.spawnPos = reelEffectsLeft.spawnPos;
        this.orbParticles.left.minStartRotation = this.starParticles.left.maxStartRotation = reelEffectsLeft.rotation;
        this.orbParticles.left.spawnRect = reelEffectsLeft.spawnRect;
        this.orbParticles.left.frequency /= reelEffectsLeft.spawnRect.height / reelEffectsBottom.spawnRect.width;

        this.orbParticles.right.spawnPos = reelEffectsRight.spawnPos;
        this.orbParticles.right.minStartRotation = this.orbParticles.right.maxStartRotation = reelEffectsRight.rotation;
        this.orbParticles.right.spawnRect = reelEffectsRight.spawnRect;
        this.orbParticles.right.frequency /= reelEffectsRight.spawnRect.height / reelEffectsBottom.spawnRect.width;
    }

    enable(): void {
        this.starParticles.top.emit = true;
        this.starParticles.bottom.emit = true;
        this.starParticles.left.emit = true;
        this.starParticles.right.emit = true;

        this.orbParticles.top.emit = true;
        this.orbParticles.bottom.emit = true;
        this.orbParticles.left.emit = true;
        this.orbParticles.right.emit = true;
    }

    disable(): void {
        this.starParticles.top.emit = false;
        this.starParticles.bottom.emit = false;
        this.starParticles.left.emit = false;
        this.starParticles.right.emit = false;

        this.orbParticles.top.emit = false;
        this.orbParticles.bottom.emit = false;
        this.orbParticles.left.emit = false;
        this.orbParticles.right.emit = false;
    }
}